import { format } from "date-fns"
import { useContext, useState, useEffect } from "react"
import { Formik, Form, Field, FieldArray } from "formik"
import { FiAlertTriangle, FiArrowRight, FiChevronUp, FiEye, FiMinus, FiPlus, FiTrash, FiUsers } from "react-icons/fi"
import { toast } from "react-toastify"
import { twMerge } from "tailwind-merge"
import { useHistory, useLocation } from "react-router-dom"
import classNames from "classnames"
import { Button, File, Select, Textarea, Textbox } from "../../../../components/Form"
import { api, authHeaders } from "../../../../services/api"
import Table from "../../../../components/Table"
import masks from "../../../../util/masks"
import formUtils from "../../../../util/form"
import arrayUtils from "../../../../util/array"
import scrollUtils from "../../../../util/scroll"
import { GlobalContext } from "../../../../contexts/GlobalContext"
import Spinner from "../../../../components/Spinner"
import Modal from "../../../../components/Modal"
import { openTabSafari } from "../../../../util/file"

export function EtapaDetalhe({ etapaAberta, etapaPessoaAbertaId, projeto, onChangePessoasLista, onChangeToggleTarefa, onSubmitRelatorio, onChangeDocumentos, onCreateTarefa }) {
	const { user, checkException } = useContext(GlobalContext)

	const history = useHistory()
	const { state } = useLocation()

	const [mostrarInclusaoPessoa, setMostrarInclusaoPessoa] = useState(false)
	const [isLoadingDadosParticipante, setIsLoadingDadosParticipante] = useState(false)
	const [dadosEtapaPessoa, setDadosEtapaPessoa] = useState(null)
	const [pessoaDadosAbertos, setPessoaDadosAbertos] = useState(null)
	const [mostrarEquipe, setMostrarEquipe] = useState(false)
	const [pessoaARemover, setPessoaARemover] = useState(null)
	const [mostrarFormNovaTarefa, setMostrarFormNovaTarefa] = useState(false)

	async function handleIncluirPessoa(values) {
		try {
			values = formUtils.extractFormValues(values)

			const { pessoa_id, pessoa_busca, ...params } = values

			await api.post(`projeto/${projeto.id}/etapa/${etapaAberta.id}/add_pessoa/${pessoa_id}`, params, authHeaders())

			onChangePessoasLista()

			setMostrarInclusaoPessoa(false)
		} catch (e) {
			checkException(e)
		}
	}

	async function handleRemoverPessoa(item) {
		try {
			await api.delete(`projeto/${projeto.id}/etapa/${etapaAberta.id}/pessoa/${item.id}`, authHeaders())

			setPessoaARemover(null)

			toast.success('Participante removido com sucesso!')

			onChangePessoasLista()
		} catch (e) {
			checkException(e)
		}
	}

	async function handleToggleTarefa(tarefa) {
		try {
			await api.patch(`projeto/${projeto.id}/etapa/${etapaAberta.id}/tarefa/${tarefa.id}/toggle`, {}, authHeaders())

			onChangeToggleTarefa()

			toast.success('Tarefa concluída.')
		} catch (e) {
			checkException(e)
		}
	}

	async function handleSubmeterRelatorio(values) {
		try {
			await api.post(`projeto/${projeto.id}/etapa/${etapaAberta.id}/pessoa/${values.projeto_etapa_pessoa_id}`, values, authHeaders())

			toast.success('Relatório submetido com sucesso.')

			onSubmitRelatorio()
		} catch (e) {
			checkException(e)
		}
	}

	async function handleObterDadosParticipante(pessoa) {
		try {
			setIsLoadingDadosParticipante(true)

			const response = await api.get(`projeto/${projeto.id}/etapa/${etapaAberta.id}/pessoa/${pessoa.projeto_pessoa_id}`, authHeaders())

			response.percentual_conclusao = etapaAberta.projeto_etapa_pessoas.find(p => p.projeto_pessoa_id === pessoa.projeto_pessoa_id).percentualConclusao

			setDadosEtapaPessoa(response)
		} catch (e) {
			checkException(e)
		} finally {
			setIsLoadingDadosParticipante(false)
		}
	}

	async function handleRemoverDocumento(arquivo) {
		try {
			await api.delete(`projeto/${projeto.id}/etapa/${etapaAberta.id}/documento/${arquivo.id}`, authHeaders())

			toast.success('Documento removido.')

			onChangeDocumentos()
		} catch (e) {
			checkException(e)
		}
	}

	async function handleIncluirTarefa(values) {
		try {
			await api.post(`projeto/${projeto.id}/etapa/${etapaAberta.id}/pessoa/${values.pessoa_etapa_id}/tarefa`, {
				...values,
				nome: values.nome_tarefa
			}, authHeaders())

			toast.success('Tarefa adicionada.')

			await onCreateTarefa(values.pessoa_etapa_id)
		} catch (e) {
			checkException(e)
		}
	}

	async function handleRemoverTarefa(tarefa) {
		try {
			await api.delete(`projeto/${projeto.id}/etapa/${etapaAberta.id}/tarefa/${tarefa.id}`, authHeaders())

			toast.success('Tarefa removida.')

			history.push({
				pathname: `/projeto/${projeto.id}`,
				state: {
					aba_selecionada_index: 2,
					etapa: etapaAberta.id,
					participante: tarefa.pessoa
				}
			})
		} catch (e) {
			checkException(e)
		}
	}

	useEffect(() => {
		if (state?.participante) {
			handleObterDadosParticipante(state.participante)

			setPessoaDadosAbertos(state.participante)

			setTimeout(() => {
				scrollUtils.toElement(`.pessoa-tarefas-details-${state.participante.id}`)
			}, 800)
		}
	}, [state])

	if (!etapaAberta || !projeto) {
		return null
	}

	const pessoasIncluidas = projeto.etapas.find(etp => etp.id === etapaAberta.id).projeto_etapa_pessoas.map(etpPessoa => {
		return {
			id: etpPessoa.id,
			pessoa_id: etpPessoa.pessoa.id,
			nome: etpPessoa.projeto_pessoa.pessoa.nome,
			condicao: etpPessoa.condicao,
			condicao_descricao: etpPessoa.condicao.descricao,
			projeto_pessoa_id: etpPessoa.projeto_pessoa_id,
			percentual_conclusao: etpPessoa.percentualConclusao || 0
		}
	})

	const eAutor = projeto.pessoas.some(p => p.id === user.pessoa.id && p.condicao.toLowerCase() === 'autor')

	let dadosParticipante = etapaAberta.projeto_etapa_pessoas
		.find(projEtpPessoa => projEtpPessoa.projeto_pessoa.pessoa.id === user.pessoa.id && [1, 2].includes(projEtpPessoa.condicao.id))

	if (dadosParticipante) {
		Object.assign(dadosParticipante, {
			percentual_conclusao: Math.round((dadosParticipante.tarefas.filter(t => t.feito).length * 100) / dadosParticipante.tarefas.length),
			tarefas: dadosParticipante.tarefas.map(tarefa => ({
				...tarefa,
				data_hora_feito: tarefa.feito ? format(new Date(tarefa.updated_at), 'dd/MM/yyyy HH:mm\'h\'') : ''
			})),
			documentos: etapaAberta.documentos
				.filter(doc => doc.pessoa.id === user.pessoa.id)
				.map(doc => ({
					id: doc.documento.id,
					pessoa: doc.pessoa.nome,
					link: doc.documento.link,
					identificador: doc.identificador
				}))
		})
	}

	async function handleUploadDocumento(values) {
		try {
			await api.post(`projeto/${projeto.id}/etapa/${etapaAberta.id}/upload/${user.pessoa.id}`, values, authHeaders())

			toast.success('Upload concluído.')

			onChangeDocumentos()
		} catch (e) {
			checkException(e)
		}
	}

	const podeDesmarcarTarefas = !dadosParticipante?.relatorio
	const todasTarefasConcluidas = dadosParticipante ? dadosParticipante.tarefas.every(t => t.feito) : false
	const documentosEtapa = etapaAberta.documentos?.map(doc => ({
		id: doc.documento.id,
		link: doc.documento.link,
		identificador: doc.identificador,
		pessoa: doc.pessoa.nome
	})) || []

	if (etapaPessoaAbertaId) {
		const pessoaAberta = pessoasIncluidas.find(pessoa => pessoa.id === etapaPessoaAbertaId)

		if (!pessoaDadosAbertos) {
			setPessoaDadosAbertos(pessoaAberta)

			handleObterDadosParticipante(pessoaAberta)
		}
	}

	const pessoasAOcultar = projeto.pessoas.filter(pp => pp.aceite === null || pp.aceite === false)

	const pessoasNoProjeto = projeto.pessoas
		.filter(p => !pessoasAOcultar.some(po => po.id === p.id))
		.sort(arrayUtils.sort.comparisonFunction('nome', 'asc'))

	const pessoasSemTarefasNestaEtapa = pessoasNoProjeto.filter(pessoa => !pessoasIncluidas.some(p => p.pessoa_id === pessoa.id))

	console.log(pessoasIncluidas)

	return (
		<>
			<div className="flex flex-col lg:grid lg:grid-cols-2 gap-2 mx-2 mt-2 pb-6">
				<div className="flex flex-col gap-2">
					<div className="flex gap-8">
						<span>
							<b className="font-bold">Início: </b>
							{format(new Date(etapaAberta.inicio), 'dd/MM/yyyy')}
						</span>

						<span>
							<b className="font-bold">Fim: </b>
							{format(new Date(etapaAberta.fim), 'dd/MM/yyyy')}
						</span>
					</div>

					<span>
						<b className="font-bold">{'Objetivo: '}</b>
						{etapaAberta.objetivo}
					</span>

					{dadosParticipante && (
						<div className="mt-6 flex flex-col gap-2">
							<span>
								<b className="font-bold">{'Valor / hora: '}</b>
								{masks.maskApply.currency(dadosParticipante.valor_hora)}
							</span>

							<span>
								<b className="font-bold">{'Observações: '}</b>
								{dadosParticipante.observacao}
							</span>
						</div>
					)}
				</div>

				{!eAutor && (
					<Button className="w-fit transparent justify-self-end" onClick={() => { setMostrarEquipe(true) }}>
						Ver equipe
						<FiUsers size={16} />
					</Button>
				)}

				<div className={classNames(
					'flex flex-col gap-4 mt-4 col-span-2',
					{
						'md:grid md:grid-cols-2': eAutor
					}
				)}>
					{eAutor ? (
						<>
							<details className="col-span-2">
								<summary className="list-none w-fit md:mt-5" onClick={() => { setMostrarInclusaoPessoa(old => !old) }}>
									{mostrarInclusaoPessoa ? (
										<div className="flex items-center gap-2 mx-3 cursor-pointer hover:opacity-80">
											<span>
												Ocultar inclusão de pessoas
											</span>

											<FiChevronUp size={16} className="group-hover:text-slate-800" />
										</div>
									) : (
										<div className={twMerge(
											'bg-white/15 border border-b-[3px] border-white py-2 px-4 w-fit flex gap-2 items-center mx-2 font-normal rounded-[4px] cursor-pointer group',
											'hover:bg-white hover:text-slate-800 transition-all'
										)}>
											<span>Incluir participante</span>

											<FiPlus size={16} className="group-hover:text-slate-800" />
										</div>
									)}
								</summary>

								<div className="flex flex-col w-full border-b pb-4 border-white/40">
									<Formik
										onSubmit={handleIncluirPessoa}
										initialValues={{
											pessoa_id: null,
											valor_hora: '',
											frequencia_relatorio: '',
											observacao: '',
											tarefas: []
										}}
									>
										{({ setFieldValue, values }) => (
											<Form className="flex flex-col w-full md:grid md:grid-cols-2 lg:grid-cols-3">
												<Select
													name="pessoa_id"
													label="Participantes"
													options={pessoasSemTarefasNestaEtapa.map(p => ({
														label: p.nome,
														value: p.id
													}))}
													onChange={(selected, meta) => {
														setFieldValue(meta.name, selected)
													}}
													hint={{
														text: 'Apenas as pessoas que aceitaram participação no projeto serão listadas.'
													}}
												/>

												<Textbox
													name="valor_hora"
													label="Valor / hora"
													mask={masks.money}
												/>

												<Textbox
													name="frequencia_relatorio"
													label="Frequência (em dias) para envio do relatório de tarefas"
													mask={masks.numero}
												/>

												<Textarea
													name="observacao"
													label="Observações"
												/>

												<FieldArray
													name="tarefas"
													render={({ push, remove }) => {
														const podeIncluirNovaTarefa = values.tarefas.every(tarefa => tarefa.descricao && tarefa.prazo)

														return (
															<div className="mt-4 flex flex-col lg:grid lg:grid-cols-[2fr_1fr] col-start-1 md:col-span-2 lg:col-span-3">
																<h2 className="font-semibold mx-2 col-span-2" style={{ fontSize: 16 }}>Discriminação das tarefas</h2>

																{values.tarefas.length ? (
																	<ul>
																		{values.tarefas.map((tarefa, idx) => (
																			<li key={tarefa.id} className="grid grid-cols-[2fr_1fr_2rem] gap-1 items-center">
																				<Textbox
																					name={`tarefas.${idx}.descricao`}
																					label="Tarefa"
																				/>

																				<Textbox
																					name={`tarefas.${idx}.prazo`}
																					label="Prazo em dias"
																					mask={masks.numero}
																				/>

																				<FiTrash
																					onClick={() => {
																						remove(idx)
																					}}
																					size={16}
																					className="mt-4"
																				/>
																			</li>
																		))}
																	</ul>
																) : (
																	<p className="italic mt-2 mx-2" style={{ fontSize: 13 }}>Nenhuma tarefa atribuída</p>
																)}

																<Button
																	className="transparent w-fit peer col-span-2"
																	style={{ marginTop: 16 }}
																	onClick={() => {
																		if (!podeIncluirNovaTarefa) {
																			return
																		}

																		push({
																			descricao: '',
																			prazo: ''
																		})
																	}}
																	disabled={!podeIncluirNovaTarefa}
																>
																	Incluir tarefa
																	<FiPlus size={16} />
																</Button>

																<p
																	className={classNames(
																		'opacity-0 flex text-center mx-2 items-center gap-1',
																		{
																			'peer-hover:opacity-100': !podeIncluirNovaTarefa,
																			'peer-hover:opacity-0': podeIncluirNovaTarefa
																		}
																	)}
																	style={{ fontSize: 12 }}
																>
																	<FiAlertTriangle size={13} />
																	Para adicionar uma nova, preencha todas as tarefas anteriores.
																</p>
															</div>
														)
													}}
												/>

												<Button type="submit" className="white self-end peer" disabled={!values.pessoa_id}>
													Incluir pessoa
													<FiPlus size={16} />
												</Button>

												<div
													style={{ fontSize: 12 }}
													className={classNames(
														'mx-2 opacity-0 bg-yellow-500 text-slate-800 p-2 rounded-md transition-opacity',
														{
															'peer-hover:opacity-100': !values.pessoa_id,
															'peer-hover:opacity-0': values.pessoa_id
														}
													)}
												>
													Você deve buscar o participante a partir do banco de talentos do sistema. Para continuar, digite o nome e aguarde que o sistema localize o cadastro.
												</div>
											</Form>
										)}
									</Formik>
								</div>
							</details>

							<div className="flex flex-col mt-1 mb-8 mx-4 col-span-2">
								<h2 className="font-[500] mb-4" style={{ fontSize: 16 }}>Equipe</h2>

								{pessoasIncluidas.length ? pessoasIncluidas.map(pessoa => {
									const eAutorProjeto = pessoa.condicao.id === 1

									return (
										<div className="flex gap-4">
											<details
												key={pessoa.id}
												className={`pessoa-tarefas-details-${pessoa.id} group open:bg-black/30 w-full`}
												open={pessoaDadosAbertos?.id === pessoa.id || etapaPessoaAbertaId === pessoa.id}
												onToggle={e => {
													setPessoaDadosAbertos(e.target.open ? pessoa : null)
												}}
											>
												<summary
													className="rounded-md border list-none cursor-pointer font-normal p-4 hover:bg-white/10 flex justify-between items-center gap-6 relative overflow-hidden select-none"
													onClick={() => {
														if (!isLoadingDadosParticipante) {
															handleObterDadosParticipante(pessoa)
														}
													}}
												>
													<span className="z-10">{pessoa.nome}</span>

													<span style={{ fontSize: 12 }}>{`${pessoa.percentual_conclusao}% concluído`}</span>

													<div className={`absolute bg-emerald-500 h-full opacity-40 w-[${pessoa.percentual_conclusao}%] left-0`} />
												</summary>

												<div className="p-4 group-open:border-x group-open:border-dashed">
													{isLoadingDadosParticipante ? (
														<Spinner />
													) : dadosEtapaPessoa ? (
														<div className="flex flex-col gap-2">
															<div className="flex gap-1">
																<span className="font-semibold">Valor / hora:</span>
																<span>{masks.maskApply.currency(dadosEtapaPessoa.valor_hora)}</span>
															</div>

															<div className="flex flex-col gap-1 border-t pt-2">
																<span className="font-semibold">Observação</span>
																<span>{dadosEtapaPessoa.observacao}</span>
															</div>

															<div className="flex flex-col gap-1 border-t pt-2">
																<div className="flex justify-between">
																	<span className="font-semibold">Relatório</span>

																	{dadosEtapaPessoa.relatorio && (
																		<span style={{ fontSize: 13 }}>{format(new Date(dadosEtapaPessoa.updated_at), 'dd/MM/yyyy HH:mm\'h\'')}</span>
																	)}
																</div>

																{dadosEtapaPessoa.relatorio ? (
																	<span>{dadosEtapaPessoa.relatorio}</span>
																) : (
																	<span className="italic" style={{ fontSize: 13 }}>Relatório não enviado.</span>
																)}
															</div>

															<div className="flex flex-col border-t pt-2 gap-2">
																<span className="font-semibold">Tarefas</span>

																<Button
																	className="transparent self-end"
																	onClick={() => {
																		setMostrarFormNovaTarefa(old => !old)
																	}}
																	tiny
																>
																	{!mostrarFormNovaTarefa ? (
																		<>
																			Incluir Tarefa
																			<FiPlus size={16} />
																		</>
																	) : (
																		<>
																			Ocultar
																			<FiMinus size={16} />
																		</>
																	)}
																</Button>

																{mostrarFormNovaTarefa && (
																	<div className="w-full">
																		<Formik
																			onSubmit={handleIncluirTarefa}
																			initialValues={{
																				pessoa_etapa_id: pessoa.id,
																				nome: '',
																				prazo: ''
																			}}
																		>
																			{({ isSubmitting }) => (
																				<Form className="flex items-end">
																					<Textbox
																						name="nome_tarefa"
																						label="Tarefa"
																					/>

																					<Textbox
																						name="prazo"
																						label="Prazo"
																						mask={masks.numero}
																					/>

																					<Field type="hidden" name="pessoa_etapa_id" />

																					<Button type="submit" className="white w-64" loading={isSubmitting}>
																						Incluir tarefa
																					</Button>
																				</Form>
																			)}
																		</Formik>
																	</div>
																)}

																{!eAutorProjeto ? (
																	<Table
																		headers={[
																			{ name: 'descricao', value: 'Tarefa' },
																			{ name: 'data_feito', value: 'Data conclusão', centered: true, style: { width: '9rem' } },
																			{ name: 'feito_icon', value: 'Executado', icon: true, tooltip: true, style: { width: '7rem' } }
																		]}
																		data={dadosEtapaPessoa.tarefas.map(tarefa => ({
																			...tarefa,
																			data_feito: tarefa.feito ? format(new Date(tarefa.updated_at), 'dd/MM/yyyy HH:mm\'h\'') : 'pendente',
																			feito_icon: {
																				icon: tarefa.feito ? 'FaCheck' : 'FaTimes',
																				tooltip: tarefa.feito ? 'Executado' : 'Não executado'
																			},
																			iconColor: tarefa.feito ? '#4caf50' : '#f44336'
																		}))}
																		actions={[
																			{
																				action: item => {
																					handleRemoverTarefa({
																						...item,
																						pessoa
																					})
																				},
																				icon: FiTrash,
																				iconSize: 16,
																				name: 'Remover tarefa'
																			}
																		]}
																		footers={[
																			{
																				colspan: 3,
																				text: `${dadosEtapaPessoa.percentual_conclusao}% concluído`,
																				align: 'right'
																			}
																		]}
																	/>
																) : (
																	<>
																		<hr className="border-white/40 mt-3" />

																		<Table
																			caption="Minhas tarefas"
																			headers={[
																				{ name: 'descricao', value: 'Tarefa' },
																				{ name: 'data_hora_feito', value: 'Data/hora conclusão', centered: true, style: { width: '11rem' } }
																			]}
																			data={dadosParticipante.tarefas}
																			checkable
																			checkedItems={dadosParticipante.tarefas.filter(t => t.feito).map(t => t.id)}
																			onCheckItem={handleToggleTarefa}
																			onUncheckItem={handleToggleTarefa}
																			showCheckAll={false}
																			checkedReadonlyItems={!podeDesmarcarTarefas ? dadosParticipante.tarefas.map(t => t.id) : []}
																			footers={[
																				{
																					text: `Percentual do MRL concluído: ${dadosParticipante.percentual_conclusao}%`,
																					align: 'center',
																					colspan: 3
																				}
																			]}
																			style={{ marginTop: 8 }}
																		/>

																		<p className="self-end" style={{ fontSize: 12 }}>Marque as tarefas na lista conforme sejam exectadas.</p>
																	</>
																)}
															</div>
														</div>
													) : null}
												</div>
											</details>

											<FiTrash
												size={16}
												onClick={() => {
													setPessoaARemover(pessoa)
												}}
												className="cursor-pointer hover:opacity-80 mt-4"
											/>
										</div>
									)
								}) : (
									<Table
										data={[]}
										emptyLabel="Nenhuma pessoa na equipe"
										style={{ marginTop: 0 }}
									/>
								)}
							</div>

							<div className="flex flex-col col-span-2">
								<h2 className="font-[500] mx-4 border-t border-white/40 pt-6" style={{ fontSize: 16 }}>Documentos da etapa</h2>

								<div className="flex flex-col md:grid md:grid-cols-[1fr_2fr] gap-4">
									<Formik
										onSubmit={handleUploadDocumento}
										initialValues={{
											arquivo: null
										}}
									>
										{({ setFieldValue, errors }) => (
											<Form className="flex flex-col">
												<File
													name="arquivo"
													label="Documento"
													onSuccess={fileId => {
														setFieldValue('arquivo', fileId)
													}}
													format="square"
													error={errors.arquivo}
													style={{ width: 'calc(100% - 16px)' }}
													previewSize={['100%', '140px']}
												/>

												<Textbox
													name="identificador"
													label="Descrição"
												/>

												<Button type="submit" className="transparent w-fit self-end" style={{ marginTop: 8 }}>
													Enviar documento
													<FiArrowRight size={16} />
												</Button>
											</Form>
										)}
									</Formik>

									<Table
										headers={eAutor ? [
											{ name: 'identificador', value: 'Documento' },
											{ name: 'pessoa', value: 'Enviado por', centered: true }
										] : [
											{ name: 'identificador', value: 'Documento' }
										]}
										data={documentosEtapa}
										style={{ marginTop: 28 }}
										actions={[
											{
												action: item => {
													openTabSafari(item.link)
												},
												name: 'Visualizar',
												icon: FiEye,
												iconSize: 16
											},
											{
												action: handleRemoverDocumento,
												name: 'Remover',
												icon: FiTrash,
												iconSize: 16,
												confirmation: 'Deseja realmente remover este documento?'
											}
										]}
										emptyLabel="Nenhum documento incluído"
									/>
								</div>
							</div>
						</>
					) : !eAutor && !!dadosParticipante ? (
						<>
							<hr className="border-white/40 mt-3" />

							<Table
								caption="Minhas tarefas"
								headers={[
									{ name: 'descricao', value: 'Tarefa' },
									{ name: 'data_hora_feito', value: 'Data/hora conclusão', centered: true, style: { width: '11rem' } }
								]}
								data={dadosParticipante.tarefas}
								checkable
								checkedItems={dadosParticipante.tarefas.filter(t => t.feito).map(t => t.id)}
								onCheckItem={handleToggleTarefa}
								onUncheckItem={handleToggleTarefa}
								showCheckAll={false}
								checkedReadonlyItems={!podeDesmarcarTarefas ? dadosParticipante.tarefas.map(t => t.id) : []}
								footers={[
									{
										text: `Percentual do MRL concluído: ${dadosParticipante.percentual_conclusao}%`,
										align: 'center',
										colspan: 3
									}
								]}
								style={{ marginTop: 8 }}
							/>

							<p className="self-end" style={{ fontSize: 12 }}>Marque as tarefas na lista conforme sejam exectadas.</p>

							<h2 className="font-[500] mx-4 border-t border-white/40 pt-6" style={{ fontSize: 16 }}>Documentos da etapa</h2>

							<div className="flex flex-col md:grid md:grid-cols-[1fr_2fr] gap-4">
								<Formik
									onSubmit={handleUploadDocumento}
									initialValues={{
										arquivo: null
									}}
								>
									{({ setFieldValue, errors }) => (
										<Form className="flex flex-col">
											<File
												name="arquivo"
												label="Documento"
												onSuccess={fileId => {
													setFieldValue('arquivo', fileId)
												}}
												format="square"
												error={errors.arquivo}
												style={{ width: 'calc(100% - 16px)' }}
												previewSize={['100%', '140px']}
											/>

											<Textbox
												name="identificador"
												label="Descricao"
											/>

											<Button type="submit" className="transparent w-fit self-end" style={{ marginTop: 8 }}>
												Enviar documento
												<FiArrowRight size={16} />
											</Button>
										</Form>
									)}
								</Formik>

								<Table
									headers={[
										{ name: 'identificador', value: 'Documento' }
									]}
									data={dadosParticipante?.documentos}
									style={{ marginTop: 28 }}
									actions={[
										{
											action: item => {
												openTabSafari(item.link)
											},
											name: 'Visualizar',
											icon: FiEye,
											iconSize: 16
										},
										{
											action: handleRemoverDocumento,
											name: 'Remover',
											icon: FiTrash,
											iconSize: 16,
											confirmation: 'Deseja realmente remover este documento?'
										}
									]}
									emptyLabel="Nenhum documento incluído"
								/>
							</div>

							<div className="col-span-2 flex flex-col mb-4 mt-2 border-t border-white/40 pt-6">
								<h2 className="font-[500] mx-2" style={{ fontSize: 16 }}>Relatório de execução da etapa</h2>

								{!todasTarefasConcluidas ? (
									<p className="mx-2 mt-2 italic">Ficará disponível quando todas as tarefas estiverem concluídas.</p>
								) : !!dadosParticipante?.relatorio ? (
									<p className="mx-2">{dadosParticipante.relatorio}</p>
								) : (
									<Formik
										initialValues={{
											relatorio: '',
											projeto_etapa_pessoa_id: dadosParticipante.id
										}}
										onSubmit={handleSubmeterRelatorio}
									>
										{() => (
											<Form className="flex flex-col">
												<Textarea
													name="relatorio"
													label="Relatório da etapa"
												/>

												<Button type="submit" className="white self-end">
													Submeter relatório
													<FiArrowRight size={16} />
												</Button>

												<Field type="hidden" name="projeto_etapa_pessoa_id" />
											</Form>
										)}
									</Formik>
								)}
							</div>
						</>
					) : null}
				</div>
			</div>

			<Modal
				isOpen={mostrarEquipe}
				handleClose={() => { setMostrarEquipe(false) }}
				title="Equipe da etapa"
			>
				<div>
					{!eAutor ? (
						<Table
							headers={[
								{ name: 'nome', value: 'Nome' },
								{ name: 'condicao_descricao', value: 'Função', centered: true }
							]}
							data={pessoasIncluidas}
							actions={eAutor ? [
								{
									action: handleRemoverPessoa,
									icon: FiTrash,
									iconSize: 16,
									name: 'Remover',
									confirmation: 'Deseja realmente remover este participante desta etapa do projeto?'
								}
							] : []}
							style={{ marginTop: 12 }}
							emptyLabel="Nenhuma pessoa na equipe"
						/>
					) : (
						<div className="flex flex-col mt-6 mb-8">
							{pessoasIncluidas.length ? pessoasIncluidas.map(pessoa => (
								<details
									key={pessoa.id}
									className="group open:bg-black/30"
									open={pessoaDadosAbertos?.id === pessoa.id}
									onToggle={e => {
										setPessoaDadosAbertos(e.target.open ? pessoa : null)
									}}
								>
									<summary
										className="border list-none cursor-pointer font-normal p-4 hover:bg-white/10 flex justify-between items-center"
										onClick={() => {
											if (!isLoadingDadosParticipante) {
												handleObterDadosParticipante(pessoa)
											}
										}}
									>
										<span>{pessoa.nome}</span>

										<span style={{ fontSize: 12 }}>{`${pessoa.percentual_conclusao}%`}</span>
									</summary>

									<div className="p-4 group-open:border-x group-open:border-dashed">
										{isLoadingDadosParticipante ? (
											<Spinner />
										) : dadosEtapaPessoa ? (
											<div className="flex flex-col gap-2">
												<div className="flex gap-1">
													<span className="font-semibold">Valor / hora:</span>
													<span>{masks.maskApply.currency(dadosEtapaPessoa.valor_hora)}</span>
												</div>

												<div className="flex flex-col gap-1 border-t pt-2">
													<span className="font-semibold">Observação</span>
													<span>{dadosEtapaPessoa.observacao}</span>
												</div>

												<div className="flex flex-col gap-1 border-t pt-2">
													<div className="flex justify-between">
														<span className="font-semibold">Relatório</span>

														{dadosEtapaPessoa.relatorio && (
															<span style={{ fontSize: 13 }}>{format(new Date(dadosEtapaPessoa.updated_at), 'dd/MM/yyyy HH:mm\'h\'')}</span>
														)}
													</div>

													{dadosEtapaPessoa.relatorio ? (
														<span>{dadosEtapaPessoa.relatorio}</span>
													) : (
														<span className="italic" style={{ fontSize: 13 }}>Relatório não enviado.</span>
													)}
												</div>

												<div className="flex flex-col border-t pt-2">
													<span className="font-semibold">Tarefas</span>

													<Table
														headers={[
															{ name: 'descricao', value: 'Tarefa' },
															{ name: 'data_feito', value: 'Data conclusão', centered: true, style: { width: '9rem' } },
															{ name: 'feito_icon', value: 'Executado', icon: true, tooltip: true, style: { width: '7rem' } }
														]}
														data={dadosEtapaPessoa.tarefas.map(tarefa => ({
															...tarefa,
															data_feito: tarefa.feito ? format(new Date(tarefa.updated_at), 'dd/MM/yyyy HH:mm\'h\'') : 'pendente',
															feito_icon: {
																icon: tarefa.feito ? 'FaCheck' : 'FaTimes',
																tooltip: tarefa.feito ? 'Executado' : 'Não executado'
															},
															iconColor: tarefa.feito ? '#4caf50' : '#f44336'
														}))}
														footers={[
															{
																colspan: 3,
																text: `${dadosEtapaPessoa.percentual_conclusao}% concluído`,
																align: 'right'
															}
														]}
													/>
												</div>
											</div>
										) : null}
									</div>
								</details>
							)) : (
								<Table
									data={[]}
									emptyLabel="Nenhuma pessoa na equipe"
									style={{ marginTop: 0 }}
								/>
							)}
						</div>
					)}
				</div>
			</Modal>

			<Modal
				isOpen={!!pessoaARemover}
				handleClose={() => {
					setPessoaARemover(null)
				}}
				title="Remover participante"
			>
				<div className="flex flex-col gap-4 mx-2">
					<p dangerouslySetInnerHTML={{
						__html: `Deseja realmente remover <span class="font-bold">${pessoaARemover?.nome}</span> desta etapa do projeto?`
					}} />

					<div className="flex gap-1 self-end">
						<Button
							onClick={() => {
								setPessoaARemover(null)
							}}
							className="transparent"
						>
							Não
						</Button>

						<Button
							onClick={() => {
								handleRemoverPessoa(pessoaARemover)
							}}
							className="white"
						>
							Sim
						</Button>
					</div>
				</div>
			</Modal>
		</>
	)
}